import {Category, Season} from "@/entities";

export type CriterionName = string | Category | Season

export interface ICriterionData<T> {
    readonly id?: number
    readonly name?: T
    readonly label?: T
    readonly description?: string
    value?: boolean
}

export interface ICriterion<T> extends ICriterionData<T> {
    value?: boolean

    key: string
    validate(): boolean
    update(data?: ICriterionData<T>): void
}

export const CRITERION_NAME_MAX_LENGTH = 50
export const CRITERION_DESCRIPTION_MAX_LENGTH = 300
